import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import dayjs from 'dayjs';
import DataGrid from '../../../../common/DataGrid/DataGrid.jsx';
import {
  dataGridDateSorter,
  dataGridSurnameSorter,
} from '../../../../common/DataGrid/sorters/DataGridSorters.jsx';
import { useDataGridTextFilter } from '../../../../common/DataGrid/filters/useDataGridTextFilter.jsx';
import { useDataGridDateRangeFilter } from '../../../../common/DataGrid/filters/useDataGridDateRangeFilter.jsx';
import { FileSearchOutlined } from '@ant-design/icons';
import { IconButton } from '../../../../common/controls/Controls.jsx';

const DissertationsTable = ({ dissertations, onDetailClick }) => {
  const { t } = useTranslation();

  // Custom settings with detail icon
  const customSettings = (dissertation) => {
    return (
      <div style={{ display: 'flex' }}>
        <IconButton
          icon={<FileSearchOutlined />}
          tooltip={t('Zobraziť detail dizertačnej práce')}
          onClick={(e) => {
            e.stopPropagation();
            onDetailClick(dissertation);
          }}
        />
      </div>
    );
  };

  const studentFilterProps = useDataGridTextFilter('student');
  const titleFilterProps = useDataGridTextFilter('title');
  const supervisorFilterProps = useDataGridTextFilter('supervisor');
  const yearDateRangeFilterProps = useDataGridDateRangeFilter('year');
  const studyProgramNameFilterProps = useDataGridTextFilter('studyProgramName');

  const columns = [
    {
      title: t('Autor'),
      dataIndex: 'student',
      width: 200,
      ...studentFilterProps,
      sorter: dataGridSurnameSorter('student'),
    },
    {
      title: t('Názov práce'),
      dataIndex: 'title',
      width: 300,
      ...titleFilterProps,
    },
    {
      title: t('Školiteľ'),
      dataIndex: 'supervisor',
      width: 200,
      ...supervisorFilterProps,
      sorter: dataGridSurnameSorter('supervisor'),
    },
    {
      title: t('Dátum obhajoby'),
      dataIndex: 'year',
      width: 150,
      render: (value) => {
        return dayjs(value).format('D.M.YYYY');
      },
      sorter: dataGridDateSorter('year'),
      ...yearDateRangeFilterProps,
    },
    {
      title: t('Študijný program'),
      dataIndex: 'studyProgramName',
      width: 220,
      ...studyProgramNameFilterProps,
    },
  ];

  return (
    <DataGrid
      customSettings={customSettings}
      optionsWidth={60}
      dataSource={dissertations || []}
      columns={columns}
      onRowClick={onDetailClick}
      showActionText={false}
      uniqueTableId={'phd-dissertations-table'}
    />
  );
};

DissertationsTable.propTypes = {
  dissertations: PropTypes.array,
  onDetailClick: PropTypes.func,
};

export default DissertationsTable;
